import React, { useState } from "react";
import AddButton from "../../Component/UI/AddButton";
import {
  MdSearch,
  MdArrowForwardIos,
  MdArrowBackIos,
  MdClose
} from "react-icons/md";
import CommonTableCheckbox from "../../../AdminPanel/Component/UI/CommonTableCheckbox";
import { LuSend } from "react-icons/lu";

export default function AddTeamMembers({ onClose, list, onSubmit }) {
  const [selectedRows, onSelectionChange] = useState([]);

  const data =
    list && list.length > 0
      ? list.map((ele, i) => ({
        sno: i + 1,
        id: ele.id,
        name: ele.name,
        email: ele.email
      }))
      : [];

  const columns = [
    { key: "sno", label: "S.No." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email Address" }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Modal Container */}
      <div className="relative bg-white w-full max-w-4xl rounded-2xl p-4 z-10">

        {/* Header */}
        <div className="flex items-center justify-between mb-6">

          <h2 className="text-xl font-semibold">Add Team Members</h2>

          {/* Empty div for symmetry */}
          <div className="w-8" />


          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-200 bg-gray-100"
          >
            <MdClose size={22} />
          </button>
        </div>

        {/* ================= Table Section ================= */}
        <div className="border rounded-lg overflow-hidden">
          <div className="flex justify-between items-center px-4 pt-4 pb-2">
            <div className="flex items-center gap-2 text-sm text-black">
              Show
              <select className="border rounded-md px-2 py-1">
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              entries
            </div>

            <div className="flex items-center gap-3 text-sm text-black">
              <div className="relative">
                <MdSearch
                  size={22}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                  type="text"
                  placeholder="Search"
                  className="w-56 pl-9 pr-3 py-2 border border-[#D9D9D9] text-gray-500 rounded-md text-sm focus:outline-none"
                />
              </div>

              <div>1-20 of 150</div>

              <div className="p-2 rounded-md bg-gray-200 text-teal-600 cursor-pointer">
                <MdArrowBackIos size={20} />
              </div>

              <div className="p-2 rounded-md bg-gray-200 text-teal-600 cursor-pointer">
                <MdArrowForwardIos size={20} />
              </div>
            </div>
          </div>

          <div className="max-h-[260px] overflow-auto">


            {(data && data.length > 0) ?
              <div className="overflow-x-auto bg-white p-4">
                <CommonTableCheckbox
                  columns={columns}
                  data={data}
                  onSelectionChange={onSelectionChange}
                />
              </div>
              :
              <div className="flex flex-col items-center justify-center py-10 text-center">

                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                  <LuSend className="text-gray-400 text-2xl" />
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-700 mb-1">
                  No users available
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-500 max-w-md">
                  They may already be part of another team or haven’t been created yet.
                </p>
              </div>
            }




          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 mt-6">
          <AddButton
            onClick={() => onSubmit(selectedRows)}
            title="Add Member"
            className="bgcolor text-white px-6"
          />
        </div>
      </div>
    </div>
  );
}